<template>
  <div style="z-index: 2000; pointer-events: none;">
    <div class="hamburger-container" :style="`height: ${sideBarHeight}%;`">
      <div class="hamburger-bg">
        <button @click="openSidebar()" class="hamburger-icon">
          <img src="../static/images/hamburger-menu-icon.png" class="" style="max-width: 25px;"/>
        </button>
      </div>
    </div>

    <div style="pointer-events: all;" :class="{ 'sidebar-container': true, hide: !isSidebarVisible }"
      @click.self="closeSidebar">
      <!-- <img
        src="../static/images/close.png"
        @click="closeSidebar()"
        class="close-btn"
      /> -->
      <div class="sidebar" style="z-index: 500000;">
        <div class="top text-center">
          <img :src="siteLogo" alt="" height="10" />
        </div>

        <!-- This container scrolls -->
        <div class="scrollable-content">
          <!-- <div :class="{ 'header-items': true }">
            <button @click="selectFilter(1)">
              <img src="../static/images/icon/popular.png" class="me-2" /><span
                >{{ $t('popular') }}</span
              >
            </button>
            <button @click="selectFilter(2)">
              <img src="../static/images/icon/promotion.png" class="me-2" /><span
                >{{ $t('promotion') }}</span
              >
            </button>
            <button @click="selectFilter(3)">
              <img src="../static/images/icon/follow.png" class="me-2" /><span
                >{{ $t('follow') }}</span
              >
            </button>
          </div> -->

          <div class="sideBarContainer">
            <div style="display: flex; align-items: center; justify-content: space-between; margin: 2.5rem 0 1rem 0;">
              <!-- <div style="display: flex; align-items: center; gap: 1rem">
                <div style="background: linear-gradient(180deg, #EF3A47 55.05%, #AE000D 117.14%); padding: 0.5rem 2rem; border-radius: 20px; font-weight: 600; color: #FFFFFF;">Casino</div>
                <div style="background: #fff; padding: 0.5rem 2rem; border-radius: 20px; font-weight: 600; color: #051016;">Sport</div>
              </div>
              <div @click="routeSideBar('/searchGames')" style="cursor: pointer;"><img src="../static/images/search-button.png" width="40px"/></div> -->

              <!-- <div class="search" style="width: 100%;">
                <div @click="routeSideBar('/searchGames')" class="search-box mx-1 d-flex align-items-center" style="background: none !important;">
                  <span class="searchBg" @click="routeSideBar('/searchGames')" style="cursor: pointer">
                    <img src="@/static/images/search-icon.png" />
                  </span>
                  <input class="searchInput" v-model="searchField" :placeholder="$t('search')" />
                </div>
              </div> -->
            </div>
            <div style="display: flex; align-items: center; gap: 0.8rem; margin-bottom: 1rem;">
              <div class="sideBarButtonsCard golden-ring-border" @click="selectFilter(1)">
                <img src="../static/images/hot-deal.png" />
                <p>{{ $t('hot') }}</p>
              </div>
              <div class="sideBarButtonsCard golden-ring-border" @click="selectFilter(2)">
                <img src="../static/images/icon/promotion.png" />
                <p>{{ $t('promotion') }}</p>
              </div>
            </div>

            <div style="display: flex; align-items: center; gap: 0.8rem; margin-bottom: 1rem;">
              <div class="sideBarButtonsCard golden-ring-border" @click="routeSideBar('/')">
                <img src="../static/images/icon/demo.png" />
                <p>{{ $t('demo') }}</p>
              </div>
              <div class="sideBarButtonsCard golden-ring-border" @click="selectFilter(3)">
                <img src="../static/images/icon/follow.png" />
                <p>{{ $t('follow') }}</p>
              </div>
            </div>

            <div style="display: flex; align-items: center; gap: 0.8rem; margin-bottom: 1rem;">
              <div class="sideBarButtonsCard golden-ring-border" @click="routeSideBar('/')">
                <img src="../static/images/icon/fish.png" />
                <p>{{ $t('Fish') }}</p>
              </div>

              <div class="sideBarButtonsCard golden-ring-border" @click="routeSideBar('/')">
                <img src="../static/images/icon/live.png" />
                <p>{{ $t('Live') }}</p>
              </div>
            </div>

            <div class="sideBarButtonsCard golden-ring-border" @click="routeSideBar('/')">
              <img src="../static/images/icon/arcadee.png" />
              <p>{{ $t('Arcade') }}</p>
            </div>
          </div>
          <div class="wallet-actions">
            <div style="width: 100%; gap: 10%; padding-bottom: 2rem;">
              <div class="sideBarButton" style="padding-left: 0 !important; gap: 1rem; margin-left: 9px; margin-bottom: 1.2rem;">
                <img src="../static/images/icon/downloadIcon.png" alt="downloadIcon" width="30px"/>
                <p>{{ $t('Download App') }}</p>
              </div>
              <div class="sideBarButton" style="padding-left: 0 !important;"
                @click="routeSideBar('/information-center/support')">
                <img src="../static/images/icon/customerService.png" alt="Support" width="45px"/>
                <p>{{ $t('online-cs') }}</p>
              </div>
              <div class="sideBarButton" style="padding-left: 0 !important; margin-left: 6px;" @click="routeSideBar('/recharge')">
                <img src="../static/images/icon/faqIcon.png" alt="Deposit" width="40px"/>
                <p>{{ $t('Faq') }}</p>
              </div>
              <div class="sideBarButton" style="padding-left: 0 !important; margin-left: 4px;" @click="routeSideBar('/recharge')">
                <img src="../static/images/icon/aboutIcon.png" alt="aboutIcon" width="30px"/>
                <p>{{ $t('About Us') }}</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import language from '../static/images/icon/language.png';
import languageHover from '../static/images/icon/language-hover.png';
import download from '../static/images/icon/download.png';
import downloadHover from '../static/images/icon/download-hover.png';
import customerService from '../static/images/icon/Vector.png';
import customerServiceHover from '../static/images/icon/customer-service-hover.png';


export default {
  props: ['sideBarHeight'],
  data: () => ({
    isSidebarVisible: false,
    // Adding the hover logic
    defaultImages: {
      language: language,
      download: download,
      customerService: customerService,
    },
    hoverImages: {
      language: languageHover,
      download: downloadHover,
      customerService: customerServiceHover,
    },
    currentImages: {
      language: language,
      download: download,
      customerService: customerService,
    }
  }),
  computed: {
    ...mapState({
      siteLogo: state => state.sideBar.siteLogo
    })
  },
  methods: {
    // Sidebar functionality
    openSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
      document.body.style.overflow = this.isSidebarVisible ? 'hidden' : '';
    },
    closeSidebar() {
      this.isSidebarVisible = false;
      document.body.style.overflow = '';
    },
    selectFilter(val) {
      this.$store.commit('setCurrentSelected', val);
      this.$router.push({ path: '/searchGames' });
      this.isSidebarVisible = false;
    },
    routeSideBar(val) {
      this.$router.push({ path: val });
      this.isSidebarVisible = false;
    },

    // Image hover functionality
    hoverImage(key) {
      this.currentImages[key] = this.hoverImages[key];
    },
    leaveImage(key) {
      this.currentImages[key] = this.defaultImages[key];
    }
  },
  mounted() {
    // 
  }
};
</script>

<style lang="less" scoped>
.hamburger-container {
  width: 100%;
  margin: 0 auto;
  position: absolute;
  z-index: 300;
}

.hamburger-bg {
  pointer-events: all;
  position: relative;
  background-color: transparent !important;
  width: 15%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 0px 10px 0px;
  overflow: hidden;
  /* Ensure the slant doesn't overflow */

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.hamburger-icon {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0;
  display: block;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 3;
}

.sidebar-container {
  position: fixed;
  top: 0;
  z-index: 1;
  // background-color: rgba(0, 15, 31, 0.85);
  background: #00000080;
  width: 610px;
  overflow: hidden;
  height: 100vh;
  visibility: visible;

  &.hide {
    visibility: hidden;
    transition: visibility 0.3s ease;

    .sidebar {
      transform: translateX(-100%);
    }

    .close-btn {
      opacity: 0;
      transition: opacity 0s ease;
    }
  }

  .close-btn {
    position: absolute;
    top: 25px;
    right: 30%;
    z-index: 1;
    opacity: 1;
    transition: opacity 1s ease;
    cursor: pointer;
  }

  .sidebar {
    width: 65%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    transition: transform 0.5s ease;
    animation-fill-mode: forwards;
    overflow: hidden;
    overflow-y: auto;
    padding: 6px 8px 20px 8px;
    transform: translateX(0%);
    // border: 5px solid #1F8AFF;
    border-left: none !important;
    border-radius: 15px !important;
    border-bottom-left-radius: 0px !important;
    background-image: url('../../src/static/images/main-bg.png');
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-color: #050f17;


    .transaction {
      p {
        color: #FFF;
        font-size: 12px;
        margin-top: -22px;
      }
    }

    .top {
      margin-bottom: 0px;
    }

    hr {
      border: 0;
      border-top: 1px solid #fff;
    }

    .el-icon-close {
      cursor: pointer;
      color: #002b34;
      margin: 0 0 10px;
    }
  }
}

.header-items {
  background-color: transparent;
  border-radius: 10px;
  padding: 5px 0;
}

.header-items button {
  font-family: "AvertaStd-Regular";
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  border: none;
  background: transparent;
  padding: 7px 20px;
  gap: 10px;
  transition: all 0.3s ease;

  img {
    max-width: 24px;
    min-width: 24px;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.2);
  }

  &:hover {
    color: #c3f9ff;
  }

  &.active {
    color: #c3f9ff;
  }
}

.transaction div {
  transition: all 0.3s ease;

  img {
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }

  p {
    transition: color 0.3s ease;
  }

  &:hover p {
    color: #ffffff;
  }
}

.my-3 .d-flex {
  transition: all 0.3s ease;

  img {
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.2);
  }
}


.header-items input {
  margin: 10px 0;
  background: #D6DAF6;
  border-radius: 50px;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.8px;
  cursor: pointer;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px 8px;
}

.scrollable-content {
  flex-grow: 1;
  // overflow-y: auto;
}

.fixed-section {
  flex-shrink: 0;
  background-color: inherit;
}

.transaction {
  p {
    color: #fff;
    font-size: 12px;
    margin-top: -22px;
  }
}


.transaction,
.my-4 {
  position: sticky;
  top: auto;
  bottom: 0;
  z-index: 2;
  background-color: inherit;
  padding: 10px 0;
}

.sidebar {
  overflow-y: auto;
  height: 100vh;
}

.sidebar-container {
  overflow: hidden;
}

.sideBarContainer {
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 1rem;
}
.sideBarButton {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
  img {
    // max-width: 30px;
    // margin-bottom: 0.5rem;
    transition: transform 0.3s ease;
  }
  p {
    color: #fff;
    font-weight: 500;
    font-size: 18px;
  }

  &:hover img {
    transform: scale(1.2);
  }
}

.sideBarButtonsCard {
  // background-color: #F7F7F7;
  // padding: 1rem 0rem 0rem 1rem;
  // border-bottom: 0.5px solid #2C5C77;
  // border-radius: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 1rem;
  height: 95px;

  img {
    max-width: 38px;
    // margin-bottom: 0.5rem;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.2);
  }

  p {
    margin: 0;
    font-weight: bold;
    color: #fff;
    text-align: center;
    /* Text color */
    font-size: 1rem;
    /* Adjust text size */
    width: 100%;
    // &:hover {
    //   background: #1F8AFF;
    //   padding: 0.5rem 0rem 0.5rem 0.5rem;
    //   border-radius: 25px;
    //   color: #fff;
    // }
  }
}

.mainContainer {
  padding: 0rem 1rem;

  .sectionCard {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    gap: 28%;
    background-color: #f7f7f7;
    padding: 0.2rem 1rem;
    border-radius: 13px;
    // border: 1px solid #dbdbdb;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;

    img {
      width: 40px;
      height: 40px;
      transition: transform 0.3s ease;
    }

    &:hover img {
      transform: scale(1.2);
    }

    p {
      font-family: "Teko", sans-serif;
      font-size: 1.2rem;
      font-weight: bold;
      color: #0A1644;
    }
  }

  .offersContainer {
    padding: 0.5rem 1rem;
    background-color: #F7F7F7;
    border-radius: 12px;
    border: 1px solid #dbdbdb;

    .offersTitle {
      font-family: "Teko", sans-serif;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      color: #0A1644;
      margin-bottom: 0.5rem;
    }

    .offersGrid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;

      .offerCard {
        display: flex;
        // flex-direction: column;
        // align-items: center;
        justify-content: space-between;
        // background-color: #f7f7f7;
        padding: 5px;
        border-radius: 9px;
        border: 1px solid #dbdbdb;
        text-align: center;

        img {
          width: 40px;
          height: 40px;
          // margin-bottom: 0.5rem;
        }

        p {
          font-family: "Teko", sans-serif;
          font-size: 0.9rem;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
}

.serviceOptions {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.serviceOptionCard {
  background-color: #FFFFFF;
  padding: 1.5rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 2rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  img {
    width: 32px;
  }

  p {
    font-family: "Teko", sans-serif;
    font-weight: bold;
    color: #002266;
    font-size: 1.2rem;
    margin: 0;
  }

  &:hover {
    background-color: #002266;

    p {
      color: #ffffff;
    }
  }
}

.wallet-actions {
  padding: 30px 0px 30px 1rem;

  .wallet-action-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 14px;
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 120px;
    height: 120px;
    text-align: center;
    cursor: pointer;

    img {
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-weight: bold;
      margin: auto 0;
    }

    &:hover {
      border-color: #252838;
    }
  }
}


@media (max-width: 515px) {
  .hamburger-bg {

    // height: 67px;
    img {
      width: 80%;
      // margin: 0 20%;
    }
  }
}

@media (max-width: 425px) {
  .sidebar-container {
    width: 100%;

    .sidebar {
      width: 79%;
    }

    .close-btn {
      right: 0;
    }
  }
}

@media (max-width: 350px) {
  .hamburger-bg {
    img {
      width: 70%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sideBar.vue